export const USERS_TABLE = {
  colUsername: 240,
  colAdministrator: 70,
}
export const ROLES_TABLE = {
  colName: 240,
}
export const QUERIES_TABLE = {
  colDatabase: 160,
  colDuration: 80,
  colKillQuery: 70,
}
export const ADMIN_TABLE = {
  colDelete: 70,
}
export const DATABASE_TABLE = {
  colRetentionPolicy: 140,
  colDuration: 80,
  colReplication: 122,
  colDelete: 160,
}
